<template>
  <section class="benefits-section">
    <b-container class="position-relative">
      <img class="benefits-bg-icon bg-icon-1" src="../assets/img/Shelter.svg" alt="Game avatar image">
      <img class="benefits-bg-icon bg-icon-2" src="../assets/img/Vet-clinic.svg" alt="Game avatar image">
      <img class="benefits-bg-icon bg-icon-3" src="../assets/img/Park.svg" alt="Game avatar image">
      <img class="benefits-bg-icon bg-icon-4" src="../assets/img/Shop.svg" alt="Game avatar image">
      <b-row>
        <b-col sm="12">
          <div class="section-text-content">
            <h4 class="benefits-title">{{$t('benefits_title')}}</h4>
            <p class="benefits-subtitle">{{$t('benefits_subtitle')}}</p>
          </div>
        </b-col>
      </b-row>
      <carousel :autoplay="true"
                :autoplayHoverPause="true"
                :items="1"
                :loop="false"
                :autoWidth="true"
                :nav="false"
                :dots="true"
                :margin="24"
                :responsive="{ 600: { items: 3 } }">
        <div v-for="slide in slides" :key="slide.id" class="benefits-slider-container">
          <div class="slider-content">
            <h3 class="title-slider">{{ $t(slide.title) }}</h3>
            <p class="content-text-slider">{{ $t(slide.text) }}</p>
          </div>
        </div>
      </carousel>
    </b-container>
  </section>
</template>
<script>
import Carousel from 'vue-owl-carousel'
export default {
  components: {
    Carousel
  },
  data () {
    return {
      slides: [
        {
          id: 1,
          title: 'benefits_slider_title_1',
          text: 'benefits_slider_content_1'
        },
        {
          id: 2,
          title: 'benefits_slider_title_2',
          text: 'benefits_slider_content_2'
        },
        {
          id: 3,
          title: 'benefits_slider_title_3',
          text: 'benefits_slider_content_3'
        },
        {
          id: 4,
          title: 'benefits_slider_title_4',
          text: 'benefits_slider_content_4'
        },
        {
          id: 5,
          title: 'benefits_slider_title_5',
          text: 'benefits_slider_content_5'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.benefits-section{
  background: #FFDC5D;
  padding-top: 80px;
  padding-bottom: 80px;
  overflow: hidden;
  .section-text-content{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    max-width: 496px;
    @media screen and (min-width: 320px) {
      max-width: unset ;
    }
    @media screen and (min-width: 768px) {
      max-width: 392px;
    }
    @media screen and (min-width: 992px) {
      max-width: 496px;
    }
    .benefits-title{
      color: #30394B;
      font-family: $main-font;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 48px;
      margin: 0 0 24px 0;
      @media screen and (min-width: 320px) {
        font-size: 32px;
      }
      @media screen and (min-width: 992px) {
        font-size: 40px;
      }
      @media screen and (min-width: 1440px) {
        font-size: 40px;
      }
    }
    .benefits-subtitle{
      color: #30394B;
      font-family: $main-font;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 33.6px;
      margin: 0 0 40px 0;
      @media screen and (min-width: 320px) {
        font-size: 24px;
      }
      @media screen and (min-width: 768px) {
        font-size: 18px;
      }
      @media screen and (min-width: 992px) {
        font-size: 24px;
      }
    }
  }

  .benefits-slider-container{
    width: 100%;
    min-width: 444px;
    display: flex;
    flex: 1 0 auto;
    height: 100%;
    border-radius: 24px;
    background:  #FFF;
    box-shadow: 0px 6.336px 15.84px 0px rgba(41, 76, 96, 0.20);
    padding: 40px;
    @media screen and (min-width: 320px) {
      min-width: 300px;
    }
    @media screen and (min-width: 768px) {
      min-width: 390px;
    }
    @media screen and (min-width: 992px) {
      min-width: 444px;
    }
    .slider-content{
      .title-slider{
        color:  #30394B;
        font-family: $main-font;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 28.8px;
        margin-bottom: 40px;
        @media screen and (min-width: 320px) {
          font-size: 24px;
          margin-bottom: 40px;
        }
        @media screen and (min-width: 768px) {
          font-size: 18px;
          margin-bottom: 0;
        }
        @media screen and (min-width: 1440px) {
          font-size: 24px;
          margin-bottom: 0;
        }
      }
      .content-text-slider{
        color: #30394B;
        font-family: $main-font;
        font-size: 16px;
        font-style: normal;
        font-weight: 300;
        line-height: 22px;
        margin: 0;
        @media screen and (min-width: 320px) {
          font-size: 16px;
        }
        @media screen and (min-width: 768px) {
          font-size: 14px;
        }
        @media screen and (min-width: 992px) {
          font-size: 16px;
        }
      }
    }
  }
  .benefits-bg-icon{
    position: absolute;
  }
  .bg-icon-1{
    top: -40px;
    left: -10%;
  }
  .bg-icon-2{
    width: 72px;
    height: 72px;
    right: 30%;
    top: -30px;
    @media screen and (min-width: 320px) {
      top: -60px;
    }
    @media screen and (min-width: 768px) {
      right: 30%;
      top: -30px;
    }
  }
  .bg-icon-3{
    width: 105px;
    height: 105px;
    right: 14%;
    top: 40px;
    @media screen and (min-width: 320px) {
      width: 55px;
      height: 55px;
      right: 70%;
      top: 100%;
    }
    @media screen and (min-width: 768px) {
      width: 105px;
      height: 105px;
      right: 14%;
      top: 40px;
    }
  }
  .bg-icon-4{
    width: 93px;
    height: 93px;
    top: -50px;
    right: -40px;
    @media screen and (min-width: 320px) {
      width: 75px;
      height: 75px;
      top: 100px;
      right: -20px;
    }
    @media screen and (min-width: 768px) {
      width: 93px;
      height: 93px;
      top: -50px;
      right: -40px;
    }
  }
}
</style>
